import { render, staticRenderFns } from "./SectionAttachment.vue?vue&type=template&id=d6bd18b8&scoped=true&"
import script from "./SectionAttachment.vue?vue&type=script&lang=js&"
export * from "./SectionAttachment.vue?vue&type=script&lang=js&"
import style0 from "./SectionAttachment.vue?vue&type=style&index=0&id=d6bd18b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bd18b8",
  null
  
)

export default component.exports